export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";